/**
 * Created by eliorc on 10/19/14.
 */

// TODO: Fix the RichTextEditor Global variable.

define(function (require) {

    window.lpTag = window.lpTag || {};

    var HtmlTextFilter = require('web-agent-utils/HtmlTextFilter');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var LocalizationHelper = require('web-agent-utils/LocalizationHelper');

    var FormRichTextEditorViewController = ViewController.extend({
        ControllerName: 'FormRichTextEditorViewController',

        LPViewMap: {
            textarea: ".lpview_form_textarea",
            ckeContainer: ".rich_text_editor_container",
            customMenuPH: ".custom_menu_ph"
        },

        initialize: function (constructorData) {
            var permutation = RichTextEditor.PERMUTATION.WEBAGENT;
            var locale = agentLEManager.getLELocaleResolverLocale();

            this.componentEvents = constructorData.events;
            this.customMenuItems = constructorData.customMenuItems;

            // setting a 'State' for the RichTextEditor
            // so if the editor is not loaded yet, we will preserve the wished state for the load event.
            this.richTextEditorState = {
                isRenderStarted: false,
                isRenderEnded: false,
                loaded: false,
                value: '',
                enabled: false
            };

        var CKOptions = {
            permutation: permutation,
            locale: locale,
            events: {
                keyPress: this.componentEvents && this.componentEvents.keyPress,
                keyDown: this.componentEvents && this.componentEvents.keyDown,
                keyUp: this.componentEvents && this.componentEvents.keyUp,
                change: this.componentEvents && this.componentEvents.change,
                resize: this.componentEvents && this.componentEvents.resize,
                load: this.onRichTextEditorLoaded.bind(this)
            },
            delegates: {
                processHTMLData: this.processHTMLData.bind(this),
                detectTextDirection: LocalizationHelper.detectTextDirection
            },
            settings: constructorData.settings,
            keystrokes: constructorData.keystrokes,
            blockedKeystrokes: constructorData.blockedKeystrokes
        };

            if (lpTag.WebAgent.logicController.hasCKEditorPTagFeature()) {
                CKOptions.configOverride = {
                    enterMode: 1 /* CKEDITOR.ENTER_P = 1 */
                };
                this.addClass(this.view, 'pTagOverride');
            }

            this.richTextEditor = new RichTextEditor(CKOptions);

            this.initComponentView();
        },
        events: function () {

        },
        render: function () {

        }

    });

    /**
     * static instance of the HTMLTextFilter with the directives for the Form Rich Text Editor.
     */
    FormRichTextEditorViewController.HtmlTextFilter = (function () {
        var innerTextTag = typeof document.createElement('A').innerText !== "undefined" ? "innerText" : "textContent";
        var HTMLFilterDirectives = {
            // set's our policy items.
            "A": function (elm) {
                var output = '';
                var isValidLink = /^(www|http|https)+/.test(elm.href);

                if (isValidLink) {
                    var newElement = document.createElement('A');
                    newElement.href = elm.href;
                    newElement.target = '_blank';
                    newElement[innerTextTag] = elm[innerTextTag];

                    output = newElement.outerHTML;
                    newElement = null;
                }
                else {
                    output = elm[innerTextTag];
                }
                return output;
            },
            "IMG": getEmojiImgHtml,
            "BR": getClearElementHtml,
            "B": getClearElementHtml,
            "STRONG": getClearElementHtml,
            "I": getClearElementHtml,
            "EM": getClearElementHtml,
            "U": getClearElementHtml
        };

        var HTMLFilterEmojiImageDirectives = {
            "IMG": getEmojiImgHtml
        };

        return {
            "processFullHtml": new HtmlTextFilter({
                directives: HTMLFilterDirectives,
                styleAttributes: {
                    'font-weight': ['bold'],
                    'text-decoration': ['underline'],
                    'font-style': ['italic']
                }
            }),
            "processOnlyImgHtml": new HtmlTextFilter({
                directives: HTMLFilterEmojiImageDirectives,
                styleAttributes: {}
            })
        };

        /**
         * This method clears all inline styles/events/classes from a received element and return it HTML string
         * @param elm
         * @returns {string} clear element HTML
         */
        function getClearElementHtml(elm) {
            var clearElementHtml = "";
            if (elm && elm.tagName) {
                var newElement = document.createElement(elm.tagName);
                newElement.innerHTML = elm.innerHTML;
                clearElementHtml = newElement.outerHTML;
                newElement = null;
            }
            return clearElementHtml;
        }

        function getEmojiImgHtml(elm) {
            var output = '';

            if (elm.hasAttribute('data-emojicode')) {
                output = elm.outerHTML;
            }
            else {
                output = elm[innerTextTag];
            }
            return output;
        }
    })();


    /**
     * Processing incoming HTML data with the HTMLTextFilter and the class roles.
     * @param {string} data - raw html string
     * @returns {string} - filtered html.
     */
    FormRichTextEditorViewController.prototype.processHTMLData = function (data, filter) {
        var retVal = '';
        if (data) {
            retVal = FormRichTextEditorViewController.HtmlTextFilter[filter].processHTML(data);
        }
        return retVal;
    };

    /**
     * render the component into the dom.
     *
     * the reason that this is not part of the normal flow and there is a need to directly call the
     * render is because we are using DocumentFragments and CKEditor lookup's fails if the element is not
     * a part of the dom.
     */
    FormRichTextEditorViewController.prototype.renderComponent = function (doneCallback) {
        //if we are in render mode, we will preserve the callback on the state object and terminate the request
        this.richTextEditorState.onRenderCallback = doneCallback;
        if (this.richTextEditorState.isRenderStarted) {
            return;
        }

        function onRenderDoneCallback() {
            this.richTextEditorState.isRenderEnded = true;

            // when the UI is ready, render the custom menu items.
            this.setCustomMenuItems();

            if (this.richTextEditorState.onRenderCallback) {
                this.richTextEditorState.onRenderCallback();
            }
            this.setValue('');
        }

        this.richTextEditor.render(this.richTextEditorContainer, onRenderDoneCallback.bind(this));
        this.richTextEditorState.isRenderStarted = true;
    };

    FormRichTextEditorViewController.prototype.setCustomMenuItems = function () {
        var self = this;
        var menuItems = this.customMenuItems;
        if (menuItems && menuItems.length > 0) {
            createMenuItemsPlaceHolder(getCKEditorContainerToAttach());
            setMenuItems();
        }

        function getCKEditorContainerToAttach() {
            var toolbarElement = self.richTextEditor.getToolbarElement();
            // climbing up to the parent because the toolbar is z-index scoped.
            return toolbarElement.parentElement;
        }

        function createMenuItemsPlaceHolder(container) {
            if (container) {
                container.appendChild(createContainerPH());
            }

            function createContainerPH() {
                var phElement, toolbarContinar;
                phElement = document.createElement('ul');
                phElement.className = 'custom_menu_ph';
                toolbarContinar = self.getFirstElement('.cke_toolbar');
                phElement.style.left = toolbarContinar ? toolbarContinar.clientWidth + 'px' : '0';
                return phElement;
            }
        }

        function setMenuItems() {
            var phElement = self.getFirstElement(self.LPViewMap.customMenuPH);
            for (var i = 0; i < menuItems.length; i++) {
                if (menuItems[i] && menuItems[i].hasOwnProperty('viewController') &&
                    menuItems[i].viewController instanceof ViewController) {
                    phElement.appendChild(createListItem(menuItems[i]));
                }
            }

            function createListItem(customMenuItem) {
                var liElement = document.createElement('li');
                if (customMenuItem.className) {
                    liElement.className = customMenuItem.className;
                }

                self.addViewController({
                    viewController: customMenuItem.viewController,
                    target: liElement
                });

                return liElement;
            }
        }
    };

    /**
     * initializing the inner container for the rich text editor, loading the template.
     */
    FormRichTextEditorViewController.prototype.initComponentView = function () {
        this.createView({
            templateFile: "LP_form_richtexteditor.html",
            wrapWithDiv: false
        });

        this.richTextEditorContainer = this.getFirstElement(this.LPViewMap.textarea);
    };

    /**
     * get the rendered to screen state status.
     * @returns {boolean}
     */
    FormRichTextEditorViewController.prototype.isRendered = function () {
        return this.richTextEditorState.isRenderEnded;
    };

    /**
     * setting up the editor after it's load - using the editor state.
     */
    FormRichTextEditorViewController.prototype.onRichTextEditorLoaded = function () {
        function onSetValueDone() {
            this.richTextEditor.setEnabled(this.richTextEditorState.enabled);
            this.richTextEditorState.loaded = true;
            if (this.componentEvents && this.componentEvents.load && typeof this.componentEvents.load === "function") {
                this.componentEvents.load();
            }
        }

        if (this.richTextEditorState && !this.richTextEditorState.loaded) {
            this.richTextEditor.setValue(this.richTextEditorState.value, onSetValueDone.bind(this));
        }

    };

    FormRichTextEditorViewController.prototype.insertHTML = function (options) {
        this.richTextEditor.insertHTML(options);
    };

    /**
     * return the DOM Element wrapping the rich text editor.
     * @returns {DOMElement}
     */
    FormRichTextEditorViewController.prototype.getEditorContainer = function () {
        // check if the container loaded, if not, raise error, else return the container.
        var retVal = null;
        if (this.richTextEditorState.loaded) {
            retVal = this.richTextEditor.getEditableContainer();
        }
        return retVal;
    };

    /**
     * get's the value from the rich text editor.
     * @param {boolean} [isCleanText]  flag to remove all html tags and return clean string content.
     * @param {boolean} [isTrimmed] remove all white space and &nbsp; from the html editor.
     * @param isUnsanitized - remove the sanitize comment protection.
     * @returns {*}
     */

// TODO: move to object notation instead of properties.
    FormRichTextEditorViewController.prototype.getValue = function (isCleanText, isTrimmed, isSanitized) {

        var value = this.richTextEditor.getValue(isSanitized, false);
        if (isCleanText) {
            // return the clean text (no tags)
            value = value.replace(/(<([^>]+)>)/ig, "");
        }

        if (isTrimmed) {
            // removing all white space.
            value = value.replace(/^\s+/ig, '');
            value = value.replace(/\s+$/ig, '');

            // replacing all encoded white space '&nbsp;' with spaces.
            value = value.replace(/&nbsp;/ig, ' ');
        }

        return value;
    };

    /**
     * return the innerText of the container element.
     * @returns {*}
     */
    FormRichTextEditorViewController.prototype.getTextValue = function (processHandler) {
        return this.richTextEditor.getTextValue(processHandler);
    };

    /**
     * check if the value don't have visible content to the user.
     * @returns {boolean}
     */
    FormRichTextEditorViewController.prototype.isEmpty = function () {
        // removing all the spaces.
        var cleanStringValue = this.richTextEditor.getValue() || "";

        // removing every white space.
        cleanStringValue = cleanStringValue.replace(/(<([^>]+)>)|\s|(&nbsp;)/ig, "");

        if (cleanStringValue === '') {
            // no strings found, checking for images [icons and visible content]
            if (!this.containImages()) {
                return true;
            }
        }

        return false;
    };

// TODO: check if i can restore this functionality in ltr.
    /**
     * gets the editor value and un-wrapped the html from it's root element.
     * ex: '<p>some text</p>' -> 'some text'
     *     '<p>some<span>text</span></p>' -> 'some<span>text</span>'
     * @returns {*}
     */
//FormRichTextEditorViewController.prototype.getUnwrappedValue = function () {
//    var retVal = this.richTextEditor.getValue();
//    if (retVal) {
//        var doc = document.createElement('div');
//        doc.innerHTML = retVal;
//        if (doc.childNodes.length && doc.childNodes.length === 1 && doc.childNodes[0].innerHTML && (doc.childNodes[0].style)) {
//            retVal = doc.childNodes[0].innerHTML;
//        }
//        doc = null;
//    }
//    return retVal;
//};

    /**
     * set's the value on the rich text editor
     * @param {string} value
     */
    FormRichTextEditorViewController.prototype.setValue = function (value, cb) {
        if (this.richTextEditorState.loaded) {
            if (!value) {
                this.richTextEditor.clear(cb);
            } else {
                this.richTextEditor.setValue(value, cb);
            }
        }
        else {
            this.richTextEditorState.value = value;
            if (cb) {
                cb();
            }
        }
    };

    FormRichTextEditorViewController.prototype.clear = function (cb) {
        if (this.richTextEditorState.loaded) {
            this.richTextEditor.clear(cb);
        }
        else {
            this.richTextEditorState.value = '';
            if (cb) {
                cb();
            }
        }
    };


    /**
     * check if the content contains images
     * @returns {boolean}
     */
    FormRichTextEditorViewController.prototype.containImages = function () {
        var contentElement = document.createElement('div');
        contentElement.innerHTML = this.getValue();
        var images = contentElement.getElementsByTagName('img');
        var hasImages = (images.length > 0);

        contentElement = null;
        images = null;

        return hasImages;
    };


    /**
     * set's the enabled/disabled state.
     * @param {boolean} [isEnabled]
     */
    FormRichTextEditorViewController.prototype.setEnabled = function (isEnabled) {

        if (typeof(isEnabled) === 'undefined') {
            isEnabled = true;
        }

        if (this.richTextEditorState.loaded) {
            this.richTextEditor.setEnabled(isEnabled);
        }
        else {
            this.richTextEditorState.enabled = isEnabled;
        }
    };

    FormRichTextEditorViewController.prototype.isEnabled = function () {
        if (!this.richTextEditorState.loaded) {
            return false;
        }

        return this.richTextEditor.getEnabled();
    };

    /**
     * set focus on the rich text editor
     */
    FormRichTextEditorViewController.prototype.lpFocus = function (delayed) {
        this.calacCustomMenuItemWith();
        this.richTextEditor.setFocus(delayed);
    };

    FormRichTextEditorViewController.prototype.calacCustomMenuItemWith = function () {
        var toolbarContinar = this.getFirstElement('.cke_toolbar');
        var phElement = this.getFirstElement('.custom_menu_ph');
        phElement.style.left = toolbarContinar ? toolbarContinar.clientWidth + 'px' : '0px';
    };
    /**
     * disposing the view and releasing resources.
     */
    FormRichTextEditorViewController.prototype.dispose = function () {
        this.richTextEditor.close();
        this.richTextEditor = null;
        delete this.richTextEditor;

        for (var i = 0; i < this.customMenuItems.length; i++) {
            if (this.customMenuItems[i] && this.customMenuItems[i].dispose) {
                this.customMenuItems[i].dispose();
            }
        }


    };

    FormRichTextEditorViewController.prototype.setButtonActiveMode = function (name, isActive) {
        this.richTextEditor.setButtonActiveMode(name, isActive);
    };

    return FormRichTextEditorViewController;

});
